import { render, staticRenderFns } from "./widgetTagsViewer.vue?vue&type=template&id=65c099f0&scoped=true"
import script from "./widgetTagsViewer.vue?vue&type=script&lang=js"
export * from "./widgetTagsViewer.vue?vue&type=script&lang=js"
import style0 from "./widgetTagsViewer.vue?vue&type=style&index=0&id=65c099f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c099f0",
  null
  
)

export default component.exports